export default function ResultScreen({
  topic,
  gradeInfo,
  score,
  problems,
  attempts,
  xp,
  onTryAgain,
  onMoreTopics,
  onHome,
}) {
  return (
    <div className="slide-up" style={{
      position: "relative", zIndex: 1, padding: "40px 20px",
      maxWidth: "600px", margin: "0 auto", textAlign: "center"
    }}>
      <div className="float" style={{ fontSize: "80px", marginBottom: "16px" }}>
        {score === problems.length ? "🏆" : score >= problems.length * 0.7 ? "⭐" : "💪"}
      </div>
      <h1 style={{
        fontFamily: "'Fredoka One', cursive",
        color: "white",
        fontSize: "clamp(36px, 7vw, 56px)",
        margin: "0 0 8px",
      }}>
        {score === problems.length ? "Perfect Score!" : score >= problems.length * 0.7 ? "Great Job!" : "Keep Practicing!"}
      </h1>
      <p style={{ color: "#a0b4ff", fontSize: "18px", marginBottom: "32px" }}>
        You got <strong style={{ color: gradeInfo?.color }}>{score}</strong> out of <strong style={{ color: "white" }}>{problems.length}</strong> correct!
      </p>

      {/* Stats */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "16px",
        marginBottom: "32px",
      }}>
        {[
          { label: "Score", value: `${Math.round((score / problems.length) * 100)}%`, emoji: "📊" },
          { label: "XP Earned", value: `+${score * 10}`, emoji: "⭐" },
          { label: "Topic", value: topic?.name?.split(" ")[0], emoji: topic?.emoji },
        ].map(({ label, value, emoji }) => (
          <div key={label} style={{
            background: "rgba(255,255,255,0.06)",
            borderRadius: "16px",
            padding: "20px",
            border: "1px solid rgba(255,255,255,0.1)",
          }}>
            <div style={{ fontSize: "28px", marginBottom: "8px" }}>{emoji}</div>
            <div style={{ color: "white", fontFamily: "'Fredoka One', cursive", fontSize: "24px" }}>{value}</div>
            <div style={{ color: "#7a8fd4", fontSize: "13px", marginTop: "4px" }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Wrong answers review */}
      {Object.keys(attempts).length > 0 && (
        <div style={{
          background: "rgba(255,255,255,0.05)",
          borderRadius: "16px",
          padding: "20px",
          marginBottom: "24px",
          border: "1px solid rgba(255,255,255,0.08)",
          textAlign: "left",
        }}>
          <p style={{ color: "#FF8B8B", fontWeight: 800, marginBottom: "12px", fontSize: "15px" }}>
            📚 Review these:
          </p>
          {Object.keys(attempts).map(idx => (
            <div key={idx} style={{ marginBottom: "10px", padding: "10px", background: "rgba(255,107,107,0.08)", borderRadius: "10px" }}>
              <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "14px", marginBottom: "4px" }}>
                {problems[parseInt(idx)].q}
              </div>
              <div style={{ color: "#4ECDC4", fontSize: "13px", fontWeight: 700 }}>
                Answer: {problems[parseInt(idx)].a}
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
        <button
          className="btn-primary"
          onClick={onTryAgain}
          style={{
            background: gradeInfo?.color || "#6C63FF",
            border: "none",
            borderRadius: "14px",
            padding: "14px 28px",
            color: "white",
            fontSize: "16px",
            fontWeight: 800,
            cursor: "pointer",
            transition: "transform 0.15s",
          }}>
          🔄 Try Again
        </button>
        <button
          className="btn-primary"
          onClick={onMoreTopics}
          style={{
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "14px",
            padding: "14px 28px",
            color: "white",
            fontSize: "16px",
            fontWeight: 800,
            cursor: "pointer",
            transition: "transform 0.15s",
          }}>
          📚 More Topics
        </button>
        <button
          className="btn-primary"
          onClick={onHome}
          style={{
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: "14px",
            padding: "14px 28px",
            color: "#a0b4ff",
            fontSize: "16px",
            fontWeight: 800,
            cursor: "pointer",
            transition: "transform 0.15s",
          }}>
          🏠 Home
        </button>
      </div>
    </div>
  );
}
